import { render, staticRenderFns } from "./modalHistorialMovimiento.vue?vue&type=template&id=248dc6a4&scoped=true"
import script from "./modalHistorialMovimiento.vue?vue&type=script&lang=js"
export * from "./modalHistorialMovimiento.vue?vue&type=script&lang=js"
import style0 from "./modalHistorialMovimiento.vue?vue&type=style&index=0&id=248dc6a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248dc6a4",
  null
  
)

export default component.exports